import * as React from 'react';

import Dropdown from 'af-components/Controls/Dropdown';

interface Props {
	showEditOption: boolean;
	showViewHistoryOption: boolean;
	areAllTimeSheetsAndSplitsReadOnly: boolean;
	onTimeSheetsBulkEditClick: () => void;
	openHistory: () => void;
}

interface DropdownOption {
	label: string;
	onClick: () => void;
}

const ActionDropdown: React.FC<Props> = (props) => {

	const {
		areAllTimeSheetsAndSplitsReadOnly,
		onTimeSheetsBulkEditClick,
		openHistory,
		showEditOption,
		showViewHistoryOption,
	} = props;

	const actionOptions = React.useMemo(() => {

		const options: DropdownOption[] = [];

		if (showEditOption) {
			options.push({
				label: areAllTimeSheetsAndSplitsReadOnly ? 'Preview' : 'Edit',
				onClick: onTimeSheetsBulkEditClick,
			});
		}

		if (showViewHistoryOption) {
			options.push({
				label: 'View History',
				onClick: openHistory,
			});
		}

		return options;
	}, [areAllTimeSheetsAndSplitsReadOnly, onTimeSheetsBulkEditClick, openHistory, showEditOption, showViewHistoryOption]);

	return (
		<div>
			<Dropdown<DropdownOption>
				containerClassName=""
				id="timeSheetActions"
				isActionDropdown={true}
				labelKey="label"
				options={actionOptions}
			/>
		</div>
	);
};

export default React.memo(ActionDropdown);
